var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "modal" } },
    [
      _c("transition", { attrs: { name: "modal" } }, [
        _c("div", { staticClass: "modal__mask" }, [
          _c("div", { staticClass: "modal__wrapper" }, [
            _c("div", { staticClass: "modal__container" }, [
              _c("div", { staticClass: "modal__header" }, [
                _c("h1", { staticClass: "h1" }, [_vm._v(_vm._s(_vm.modalMsg))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__body" }, [
                _c("p", { staticClass: "lead-text" }, [
                  _vm._v(_vm._s(_vm.modalText))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__footer text-align--right" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button--tertiary",
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [_vm._v("OK")]
                )
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cda81a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cda81a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/components/contact-modal.vue
// module id = 51
// module chunks = 0